export enum InputWidthVariant {
  FULL = 'full',
  MIN = 'min',
  AUTO = 'auto',
  SMALL = 'small',
}

export enum InputSizeVariant {
  SMALL = 'small',
  DEFAULT = 'medium',
}
